export enum CourseCategory {
  AI_DATA_ENGINEERING = 'AI & Data Engineering',
  DATA_SCIENCE_ANALYTICS = 'Data Science & Analytics',
}
